import { atom } from "recoil";

export const playerBanAddModalStore = atom({
	key: "playerBanAddModalStore",
	default: {
		show: false,
		loaded: false,
		uid: false,
		reason: "",
		banType: false,
		date: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
